// custom-option.ts
import { ToastrConfig as TC } from 'ngx-toastr';

export class ToastrConfig {
  static getConfig(): TC {
    return {
      progressBar: true,
      progressAnimation: 'decreasing',
      timeOut: 5000,
      positionClass: 'toast-top-right',
      closeButton: true,
      enableHtml: true
    } as TC;
  }
}
